import type { FeatureFlagAdminListResponseType } from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";

export const useFeatureFlagAdminList = () => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  const businessId = business?.id ?? 0;

  return useQuery({
    queryKey: ["feature-flags", "admin", businessId],
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: "feature-flags/admin",
        params: { businessId },
      }).then(
        (response) =>
          apiV2AssertResponse<FeatureFlagAdminListResponseType>(response).data,
      ),
    enabled: !!businessId,
  });
};
